// Shared visual tokens for the Checkout Products screens, matching
// CheckoutAnalyticsPage: brand green plus green-tinted neutrals.

export const G = "#04b85c";
export const G_SOFT = "#e9f9f0";
export const INK = "#0e1f18";
export const BODY = "#3c4a43";
export const MUTED = "#7b8a83";
export const LINE = "#e6ebe8";
export const ACCOUNT = "#1565c0";
export const ACCOUNT_SOFT = "#e7f0fa";
export const CONTACT = "#b95000";
export const CONTACT_SOFT = "#fdf1e7";
export const WARN = "#c62828";
export const MONO = "ui-monospace, SFMono-Regular, Menlo, monospace";

export const PAGE_BG = "#f5f8f6";
export const PANEL_BG = "#f7faf8";

export const CURRENCIES = ["INR", "USD", "AED"];
export const SYM = { INR: "₹", USD: "$", AED: "AED " };

// Only INR is wired end-to-end through redeem/Chargebee provisioning; USD/AED
// would mis-bill AFTER the buyer has paid. CURRENCIES/SYM stay full for
// rendering old products. Widen this the day USD/AED are wired.
export const SELECTABLE_CURRENCIES = ["INR"];

/**
 * Opts out of the app theme's global field styling (src/themes/default.js gives
 * every MuiTextField a grey fill, extra padding and `border: none`), so these
 * screens can use white bordered fields.
 *
 * The `&&` / `&&&` repetition is specificity, not a typo — the theme's own rules
 * use `&&& $input`, so a single class loses to them.
 */
export const fieldReset = {
  "&.MuiTextField-root": { backgroundColor: "transparent", padding: 0, borderRadius: 9 },
  "& .MuiOutlinedInput-root": { borderRadius: 9, backgroundColor: "#fff" },
  "&& .MuiOutlinedInput-notchedOutline": { border: "1px solid #cdd7d1" },
  "&& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#c6d3cc" },
  "&& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: G, borderWidth: 1, boxShadow: `0 0 0 3px ${G}22`,
  },
  "&&& .MuiOutlinedInput-input": { padding: "9px 12px" },
  // Disabled reads as a flat tinted panel, so a computed read-only figure never
  // looks as editable as the inputs beside it.
  "&& .MuiOutlinedInput-root.Mui-disabled": { backgroundColor: "#f2f5f3" },
  "&& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": { border: "1px solid #eaefec" },
};

// "₹1,20,000" — the one place amounts get formatted for display.
export const money = (n, currency = "INR") =>
  `${SYM[currency] || `${currency} `}${(Number(n) || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
